export const ProductsSearchAPILimit = 20

export const ProductConfigureAccordionId = {
  Variants: 'Variants',
  Ingredients: 'Ingredients',
  AddonGroup: (index: number) => `AddonGroup-${index}`,
}
